<template>
	<div id="content_body">
		<!-- :instanceClass="instanceClassAttr.instanceClass" -->
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<!-- @submit.prevent="handleSubmit()" -->
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderDate')}}
									</label>
									<input type="date" v-model="instance.orderDate" class="form-control" lang="fr"
									:class="{'is-invalid': v$.instance.orderDate.$error, 'is-valid': (!v$.instance.orderDate.$error && v$.instance.orderDate.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderDate.$error">
										{{ v$.instance.orderDate.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.orderNumber')}}
									</label>
									<input type="text" v-model="instance.orderNumber" class="form-control"
									:class="{'is-invalid': v$.instance.orderNumber.$error, 'is-valid': (!v$.instance.orderNumber.$error && v$.instance.orderNumber.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.orderNumber.$error">
										{{ v$.instance.orderNumber.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>

							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.prsStore')}}
									</label>

									<select v-model="prsStoreSelected" 
										class="form-control" :class="{'is-invalid': v$.instance.prsStore.$error, 'is-valid': (!v$.instance.prsStore.$error && v$.instance.prsStore.$dirty) }" :disabled="typeView=='show'">
										<option value="null" selected>
											{{$t('default.fill.field.message')}}
										</option>
										<option v-for="prsStore in prsStoreList" :value="prsStore.id" :key="prsStore.id" >
										{{ prsStore.storeName }}
										</option>
									</select>
									<!-- <b-form-select
										class="form-control"
										v-model="prsTeamSelected" 
										value-field="id"
										text-field="lib"
										:options="prsTeamList"
										:class="{'is-invalid': v$.instance.prsTeam.$error, 'is-valid': (!v$.instance.prsTeam.$error && v$.instance.prsTeam.$dirty) }"
									/> -->

									<span class="small text-muted d-none d-md-block" v-if="v$.instance.prsStore.$error">
										{{ v$.instance.prsStore.$errors[0].$message }}
									</span>									
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.livreurId')}}
									</label>
									<input v-if="typeView == 'show'" type="text" v-model="instance.livreur" class="form-control" disabled/>

									<auto-search v-if="typeView != 'show'" :paramsSearch="paramsSearch" @updateOnClick="addLivreur" :class="{'is-invalid': v$.instance.livreurId.$error, 'is-valid': (!v$.instance.livreurId.$error && v$.instance.livreurId.$dirty) }"/>
									<input type="text" v-model="instance.livreurId" class="form-control" :class="{'is-invalid': v$.instance.livreurId.$error, 'is-valid': (!v$.instance.livreurId.$error && v$.instance.livreurId.$dirty) }" hidden=""/> 
									<span style="color:red;" class="small d-none d-md-block" v-if="v$.instance.livreurId.$error">
										{{ v$.instance.livreurId.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.transporteurId')}}
									</label>
									
									<input v-if="typeView == 'show'" type="text" v-model="instance.transporteur" class="form-control" disabled/>
									
									<auto-search v-if="typeView != 'show'" :paramsSearch="paramsSearch" @updateOnClick="addTransporteur" />

									<input type="text" v-model="instance.transporteurId" class="form-control" :class="{'is-invalid': v$.instance.transporteurId.$error, 'is-valid': (!v$.instance.transporteurId.$error && v$.instance.transporteurId.$dirty) }" hidden=""/>
									<!-- hidden="" -->
									<span style="color:red;" class="small d-none d-md-block" v-if="v$.instance.transporteurId.$error">
										{{ v$.instance.transporteurId.$errors[0].$message }}
									</span>
								</b-form-group>
							</div>


							
								
						</div>
						
					</b-form>
					
				</div>
				<div class="card-body p-4 p-md-5">
					<!-- Ops table-->
					<div class="table-responsive">
						<span class="small text-muted d-none d-md-block" v-if="v$.instance.servOps.$error">
							{{ v$.instance.servOps.$errors[0].$message }}
						</span>
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="25%">
										{{ $t(instanceClassAttr.instanceClass+'.servType')}}
									</th>
									<th scope="col" width="10%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantity')}}
									</th>
									<th v-if="!isNaN(itemId)" scope="col" width="15%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.quantityLiv')}}
									</th>
									<th scope="col" width="25%" class="align-center">
										{{ $t(instanceClassAttr.instanceClass+'.observation')}}
									</th>
									<th v-if="!isNaN(itemId)" scope="col" width="10%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.cost')}}
									</th>
									<th v-if="!isNaN(itemId)" scope="col" width="25%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.amount')}}
									</th>
									<!-- <th scope="col" v-if="typeView != 'show'" width="10%" class="align-center">
										{{ $t('default.actions')}}
									</th> -->
								</tr>
							</thead>
							<tbody>
								
								<tr class="border-bottom" v-for="servOp in instance.servOps" :key="servOp.id">
									<!--  -->
									<td>
										<div class="font-weight-bold">
											{{servOp.servTypeLib}}
											<div>
												<h6>
													<b-badge variant="warning" style="color: white !important;">
														<!-- servOp.servTypeStockS.cost -->
														<!-- {{servOp.stock ? (+'| Stock: '+ servOp.stock) : +''}} -->
														Prx: {{$store.getters.formatAmount(servOp.cost)}} | Stock: {{servOp.stock}}
													</b-badge>
												</h6>
											</div>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="number" :max="servOp.stock" v-model="servOp.quantity" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
									<td v-if="!isNaN(itemId)">
										<div class="small text-muted d-none d-md-block">
											<input type="number" :max="servOp.stock" v-model="servOp.quantityLiv" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
									<td>
										<div class="small text-muted d-none d-md-block">
											<input type="text" v-model="servOp.observation" class="form-control" :disabled="typeView=='show'"/>
										</div>
									</td>
									<td v-if="!isNaN(itemId)">
										<!-- <input type="text" :value="$store.getters.formatAmount(servOp.cost)" class="form-control font-weight-bold align-right" disabled=""/> -->
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount(servOp.cost)}}
										</div>
									</td>
									<td v-if="!isNaN(itemId)">
										<!-- <input type="text" :value="$store.getters.formatAmount((servOp.cost * servOp.quantity) )" class="form-control font-weight-bold align-right" disabled=""/> -->
										<div class="font-weight-bold align-right">
											{{$store.getters.formatAmount( servOp.cost * servOp.quantity )}}
										</div>
									</td>
									<!-- <td v-if="typeView != 'show'" class="align-center">
										<div class=""> 
											<button class="btn btn-danger btn-icon btn-xs" @click="removeRow(servOp)">
												<fa icon="minus"/>
											</button>
										</div>
									</td> -->

								</tr>
								<tr v-if="instance.cost" class="border-bottom table-warning">
									<td align="center" colspan="4" >
										<div class="fw-bold fs-2 align-right" >
											Total du bon
										</div>
									</td>
									<td align="center" colspan="2" >
										<div class="fw-bold fs-2 align-right">
											{{$store.getters.formatAmount(instance.cost)}}
										</div>
									</td>
								</tr>
								
							</tbody>
						</table>
					</div>
				

				</div>

				<div class="card-footer">
					<!-- :disabled="loading"  -->
					<!-- <VueSpinnerRing size="50" color="#ecaf52"/> Veuillez patienter -->
					<div class="row">
						<div class="col-md-4" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_STOCK'])" >
							<b-button v-if="typeView != 'show'" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="editItem" >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show' && !instance.received && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-primary" 
								@click="editItem" >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'show' && !instance.received" class="btn btn-success" 
								@click="instance.typeValid = 'valid'; axiosValid()">
								<span>
									<fa icon="check"/>
									{{ $t("servorder.button.valid")}}
								</span>
							</b-button>
							<b-button v-if="typeView == 'show' && instance.received && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-danger" 
								@click="instance.typeValid = 'invalid'; axiosValid()">
								<span>
									<fa icon="reply"/>
									{{ $t("servorder.button.invalid")}}
								</span>
							</b-button>
						</div>
						<div class="col-md-4" align="center">
							
						</div>
						<div v-if="typeView == 'show' && $store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_VENTE', 'ROLE_STOCK'])" class="col-md-4" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce()">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('prodorder.button.bord')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>

					</div>
				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'	
	
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'servOrder',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'auto-search': AutoSearch,
			'modal-pdf-viewer': ModalPdfViewer
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('servorder.label'),
				pageTitle: this.$t('servorder.list'),
				pageIcon: 'sticky-note',
				instanceClassAttr: {
					instanceClass: 'servorder',
					titleIndex: 'nav.serv',
					iconClass: 'folder',
					actCol: {
						actDisplay: true, 
						thCol: '10%',
						// actAlign: 'right',
						actAdd: true, 
						actGet: true, 
						actEdit: true, 
						actDel: true
					},
					attrsList: [
						{attrName: 'id', attrCol: '10%', searchable: true, sortable: true},
						{attrName: 'prsStoreLib', attrCol: '20%', searchable: false, sortable: true},
						{attrName: 'orderDate', attrCol: '20%', searchable: false, sortable: true},
						{attrName: 'servTypeLib', attrCol: '20%', searchable: false, sortable: true},
						// {attrName: 'servOp', attrCol: '20%', searchable: false, sortable: true},
						
						{attrName: 'username', attrCol: '20%', searchable: true, sortable: false}
					]
				},

				instance: {
					orderDate: new Date ().toISOString().split('T')[0],
					orderNumber: 'AUTO',
					livreur: '',
					transporteur: '',
					servOps:[],
					servStatus: {id:1} // en cours
				},
				vueRules: {},
				amountLetter: {},
				paramsSearch: {
					placeholder: 'Search Person',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					defaultValue: this.instance?.livreur,
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				prsStoreList: [],
				prsStoreSelected: null,
				prsPersonList:[],
				servTypeServs: {},

				// addOp
				activeAddRow: false,
				rowsAdded: {},
				typeView: 'new', // new, show, edit 

				pdfSrc:'',
				pdfName:'Bon de livraison',						
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		}, 
		async mounted () {
			
			this.$store.dispatch('initFlash');
			/*this.$nextTick(() => {
				this.$store.dispatch('unloading')
			})*/
			if(this.$store.getters.loggedIn) {
				// GET LIST prsstore
				await this.$store.dispatch('axiosGet', {
					domain: 'prsstore'
				})
				.then(response => {
					this.prsStoreList = response.data
				})
				.catch(error => {
					console.log('error catch prsStoreList == ', error.message)
				})

				// GET LIST prsPersonList
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"
				// Emp, Service stock			
				// Stock -> 2, Vente -> 3, Prod -> 4
				strParams = strParams+"&aliasList=_prsService"
				strParams = strParams+"&params1=_prsService.id&valParams1="+[2,4]+"&logParams1=inL"
				strParams = strParams+"&params2=active&valParams2="+true+"&logParams2=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
					// console.log('this.paramsSearch.filterList = ', this.paramsSearch.filterList)
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

				// GET LIST servTypeServList
				let strParams2 = "typeRender=list"
				strParams2 = strParams2+"&attrOrder=_servType.typeName&typerOrder=asc"
				// PDT			
				// Stock diff de 0
				strParams2 = strParams2+"&params1=stock&valParams1="+0+"&logParams1=neI"
				// S -> 1, P -> 2, V -> 3,
				strParams2 = strParams2+"&params2=servService.id&valParams2="+2+"&logParams2=eqL"
				strParams2 = strParams2+"&aliasList=_servType"
				// ART -> 1, PDT -> 2
				strParams2 = strParams2+"&params3=_servType.servCategory.id&valParams3="+ 2+"&logParams3=eqL"
				
				await this.$store.dispatch('axiosGet', { 
					url: '/api/servtypeserv/getbycriteria?' + strParams2
				})
				.then(response => {
					this.instance.servOps = response.data
					this.instance.servOps?.forEach(servOp =>{
						servOp.cost = servOp.servTypeStockS.cost;
						// cas edit
						this.servTypeServs[servOp.servTypeLib] = servOp
						
						// servOp.quantity = servOp.stock;
						// servOp.quantityLiv = servOp.stock;
					})
					// console.log('this.instance.servOps[0] = ', this.instance.servOps[0])
					// console.log('this.servTypeServs == ', this.servTypeServs)
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

			
				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'servorder',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						this.instance = response.data
						// console.log('this.instance == ', this.instance)
						this.instance.orderDate = this.$moment(this.instance.orderDate).format('YYYY-MM-DD').toString()
						this.instance.servOps = []
						this.instance.servOp.forEach(servOp => {
							// on charge les ops de production, en cas d'edit on aura comme new
							if(servOp?.servTypeStockES?.servService?.serviceCode == 'P' )
								this.instance.servOps?.push(servOp)
						})
						
						this.instance.servOp = [] // on annule l'objet hasMany pour traitement spécial
						this.prsStoreSelected = this.instance.prsStore.id

					})
					.catch(error => {
						console.log('error catch get servorder by itemId == ', error.message)
					})
				}
			}
			this.pageTitle = this.$t('servorder.'+this.typeView)
		},
		methods: {
			async editItem(){
				if(this.typeView == 'edit')
					this.$router.go(0)
				else {
					this.typeView = 'edit'
					this.pageTitle = this.$t('servteam.'+this.typeView)
					// on ajoute les autres stocks
					this.instance.servOps.forEach(servOp => {
						if(this.servTypeServs[servOp.servTypeLib]){
							servOp.stock = this.servTypeServs[servOp.servTypeLib].stock
							delete this.servTypeServs[servOp.servTypeLib];
						}
					})
					let servOps = Object.values(this.servTypeServs);
					this.instance.servOps.push(...servOps);
				}
			},
			createVeerules(){
				let rules = {
					instance: {
						orderDate: { required },
						orderNumber: {required},
						prsStore: {required},
						livreurId: {required},
						transporteurId: {required},
						servOps: {required},
					}
				}
				return rules
			},
			
			addLivreur(row){
				if(row){
					this.instance.livreurId = row.id?.toString()
					this.instance.livreur = row.id?.fullName
				}
				else {
					this.instance.livreurId = ''
					this.instance.livreur = ''
				}
			},
			addTransporteur(row){
				if(row){
					this.instance.transporteurId = row.id?.toString()
					this.instance.transporteur = row.id?.fullName
				}
				else {
					this.instance.transporteurId = ''
					this.instance.transporteur = ''
				}
			},
			async handleSubmit() {
				this.instance.prsStore = this.prsStoreSelected
						
				const result = await this.v$.$validate()
				if (!result){
					return
				}
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'servorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res update === ', res)
							this.$nextTick(() => {
								let msg = this.$t("servorder.label") + " N° "+res.data?.orderNumber;
								
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.typeView = 'show'
									this.$router.push('/servorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.typeView = 'show'
								// this.$router.push('/servorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error update === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'servorder',
							data: this.instance //data
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("servorder.label") + " N° "+res.data?.orderNumber;
								this.$store.dispatch('showToast', {
									type: 'success', message: this.$t('toast.created.message', { obj: msg})
								});
								this.$router.push('/servorder/show/'+res.data.id)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							// console.log('Error', error.response)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async axiosValid() { //this.instance.typeValid
				// console.log('this.instance.typeValid = ', this.instance.typeValid)
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'servorder/validorder',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res axiosValid === ', res)
							this.$nextTick(() => {
								let msg = this.$t("servorder.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/servorder/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.received.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.$router.go(0)
								// this.$router.push('/servorder/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosValid === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
					
				}
				catch (e) {
					console.log('Error ', e)
				}
			},

			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'BON DE LIVRAISON'
				let attrsRepList = ['getServType()', 'quantityLiv', 'quantity', 'tdObs']
				let attrsRepLibList = ['Produit', 'Qté. Livrée', 'Qté. reçue', 'Observation']
				
				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';
				let detailsTopC1 = '<i> '+ this.$t('servorder.orderNumber') +' : </i> <b> ' +this.instance.orderNumber + '</b>';

				detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('servorder.prsStore') +' : </i> <b> ' +this.instance.prsStore?.storeName + '</b>';

				let	detailsTopC2 = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.orderDate).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''
				let	detailsBot = '. <br>.'
				let libBot = '<i> Commentaires (Problèmes, Pannes, Solutions, Suggestions, etc.) </i>'

				let detailsBot3C = 'Visas des parties (Nom, Prénoms, Signatures)'
				let detailsBot3C1 = '<i>'+ this.$t(this.instanceClassAttr.instanceClass +'.livreurId') +'</i> <br><br><br>'
				detailsBot3C1 = detailsBot3C1 + '<b>'+ this.instance.livreur + '</b>'
				
				let detailsBot3C2 = '<i>'+ this.$t(this.instanceClassAttr.instanceClass +'.transporteurId')+'</i> <br><br><br>'
				detailsBot3C2 = detailsBot3C2 + '<b>'+ this.instance.transporteur + '</b>'
				let detailsBot3C3 = '<i>'+this.$t(this.instanceClassAttr.instanceClass +'.magasinierId') +'</i> <br><br><br><b>.............</b>'
				
				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

			
				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				if(detailsBot3C != '')
					strParams = strParams +"&detailsBot3C="+detailsBot3C
				if(detailsBot3C1 != '')
					strParams = strParams +"&detailsBot3C1="+detailsBot3C1
				if(detailsBot3C2 != '')
					strParams = strParams +"&detailsBot3C2="+detailsBot3C2
				if(detailsBot3C3 != '')
					strParams = strParams +"&detailsBot3C3="+detailsBot3C3

				let strParamsForms = "params1=servOrder.id&valParams1="+this.itemId +"&logParams1=eqL"

				// Un seul elt
				strParamsForms = strParamsForms+"&aliasList=_servTypeStockES"
				strParamsForms = strParamsForms+"&params2=_servTypeStockES.servService.id&valParams2="+2+"&logParams2=eqL"


				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()
				strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.servOp')

				let fileName = modelName + '_'+this.instance.orderNumber
				strParams = strParams + "&fileName="+ fileName
				strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.prsStore?.storeName +' ***</i></FONT> '
				await this.$store.dispatch('axiosGet', {
					url: '/api/servop/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},



		}
		
	}

</script>